import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import Icon from '../../../components/AppIcon';

const CohortAnalysis = ({ data }) => {
  const formatMonth = (dateStr) => {
    const date = new Date(dateStr);
    return date?.toLocaleDateString('en-US', { month: 'short', year: 'numeric' });
  };

  const chartData = data?.map(cohort => ({
    month: formatMonth(cohort?.cohort_month),
    retention: parseFloat(cohort?.retention_rate) || 0,
    active: cohort?.active_members || 0,
    churned: cohort?.churned_members || 0,
    total: cohort?.total_members || 0
  }));

  if (!chartData || chartData?.length === 0) {
    return (
      <div className="bg-card rounded-xl shadow-md p-6">
        <h2 className="text-lg font-semibold text-foreground mb-4">Cohort Retention Analysis</h2>
        <div className="flex flex-col items-center justify-center py-12">
          <Icon name="Users" size={48} className="text-muted-foreground mb-4" />
          <p className="text-muted-foreground">No cohort data available</p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-card rounded-xl shadow-md p-6">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h2 className="text-lg font-semibold text-foreground mb-1">Cohort Retention Analysis</h2>
          <p className="text-sm text-muted-foreground">Member retention by join month</p>
        </div>
        <Icon name="TrendingUp" size={20} className="text-muted-foreground" />
      </div>

      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={chartData}>
          <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
          <XAxis
            dataKey="month"
            stroke="var(--color-muted-foreground)"
            style={{ fontSize: '12px' }}
          />
          <YAxis
            stroke="var(--color-muted-foreground)"
            style={{ fontSize: '12px' }}
          />
          <Tooltip
            contentStyle={{
              backgroundColor: 'var(--color-card)',
              border: '1px solid var(--color-border)',
              borderRadius: '8px',
              color: 'var(--color-foreground)'
            }}
          />
          <Legend />
          <Bar
            dataKey="retention"
            name="Retention Rate (%)"
            fill="var(--color-success)"
            radius={[8, 8, 0, 0]}
          />
        </BarChart>
      </ResponsiveContainer>

      {/* Cohort Details */}
      <div className="mt-6 space-y-3">
        {chartData?.slice(0, 3)?.map((cohort, index) => (
          <div key={index} className="bg-background rounded-lg p-3">
            <div className="flex items-center justify-between mb-2">
              <span className="text-sm font-semibold text-foreground">{cohort?.month}</span>
              <span className="text-sm font-bold text-success">{cohort?.retention?.toFixed(1)}%</span>
            </div>
            <div className="grid grid-cols-3 gap-2 text-xs">
              <div>
                <div className="text-muted-foreground">Total</div>
                <div className="font-semibold text-foreground">{cohort?.total}</div>
              </div>
              <div>
                <div className="text-muted-foreground">Active</div>
                <div className="font-semibold text-success">{cohort?.active}</div>
              </div>
              <div>
                <div className="text-muted-foreground">Churned</div>
                <div className="font-semibold text-destructive">{cohort?.churned}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CohortAnalysis;